import * as React from 'react';
import { Link } from 'react-router-dom';
import { routeConstants } from 'app/routes/route-constants';

import styles from './new-case-banner.scss';
import { OpenCaseNumber } from 'app/area/startup/components/open-case/open-case';

const RX_REPLACELINK = /\{(.+?)\}/g;

const insertLink = (text: string) => {
  const split = text.split(RX_REPLACELINK);
  return split.map((item, index) => {
    if (!(index % 2)) {
      return item;
    } else {
      return <Link key={index} to={routeConstants.createFavouriteDraft}>{item}</Link>;
    }
  });
};

export interface NewCaseBannerProps {
  textHeader: string;
  textDescription: string;
  textBtnRegisterNewCase: string;
  textOpenCaseHeader: string;
  textOpenCaseDescription: string;
  textCaseNo: string;
  textOpenCase: string;
}

export const NewCaseBanner = ({
      textHeader,
      textDescription,
      textBtnRegisterNewCase,
      textOpenCaseHeader,
      textOpenCaseDescription,
      textCaseNo,
      textOpenCase
    }: NewCaseBannerProps) => (
    <div className={`${styles.newCaseBanner}`}>
      <div className={`row ${styles.newCasePanel}`}>
        <div className={`col-md-6 ${styles.newCaseContainer} ${styles.inputToBottom}`}>
          <div>
            <h1>{textHeader}</h1>
            <div className={styles.description}>
              {textDescription}
            </div>
          </div>
          <div>

          <Link to={routeConstants.selectCaseType} id="register_case"
            className={`btn btn-call-to-action ${styles.btnRegisterNewCase}`}>
              {textBtnRegisterNewCase}
          </Link>
          </div>
        </div>
        <div className={`col-md-6 ${styles.inputToBottom}`}>
          <div>
            <h2 className={`h1 ${styles.caseNumberTitle}`}>{textOpenCaseHeader}</h2>
            <div className={styles.description}>
              {insertLink(textOpenCaseDescription)}
            </div>
          </div>
          <div>
            <OpenCaseNumber textCaseNo={textCaseNo} textOpenCase={textOpenCase} expandInputField={true}/>
          </div>
        </div>
      </div>
    </div>);
